<template lang="html">
    <div
        :class="
            `ps-section--default ps-related-products ${
                boxed === true ? 'boxed' : ''
            }`
        "
    >
        <div class="ps-section__header">
            <h3>Related products</h3>
        </div>
        <div class="ps-section__content">
            <div
                class="ps-carousel"
                v-swiper:mySwiper="
                    layout === 'fullwidth' ? settingFullwidth : settingDefault
                "
            >
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="product in relatedProducts">
                        <product-default :product="product" />
                    </div>
                </div>
                <!--Carousel controls-->
<!--                <div class="swiper-nav mob-hide">-->
<!--                    <span class="swiper-arrow swiper-prev">-->
<!--                        <i class="icon-chevron-left"></i>-->
<!--                    </span>-->
<!--                    <div class="swiper-arrow swiper-next">-->
<!--                        <i class="icon-chevron-right"></i>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="swiper-pagination swiper-pagination-bullets"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getColletionBySlug } from '~/utilities/product-helper';
import ProductDefault from '~/components/elements/product/ProductDefault';

export default {
    name: 'RelatedProduct',
    components: { ProductDefault },
    props: {
        collectionSlug: {
            type: String,
            default: ''
        },
        layout: {
            type: String,
            default: ''
        },
        boxed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            collections: state => state.collection.collections,
            relatedProducts: (state) => state.product.relatedProducts,

        }),
        products() {
            return getColletionBySlug(this.collections, this.collectionSlug);
        }
    },
    data() {
        return {
            settingFullwidth: {
                loop: true,
                slidesPerView: 7,
                spaceBetween: 1,
                navigation: {
                    // nextEl: '.swiper-next',
                    // prevEl: '.swiper-prev'
                     nextEl: '',
                     prevEl: ''
                },
                breakpoints: {
                    1680: {
                        slidesPerView: 6,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    },
                    1366: {
                        slidesPerView: 5,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    },
                    1024: {
                        slidesPerView: 4,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    }
                }
            },
            settingDefault: {
                loop: true,
                slidesPerView: 5,
                spaceBetween: 1,
                navigation: {
                    // nextEl: '.swiper-next',
                    // prevEl: '.swiper-prev'
                    nextEl: '',
                    prevEl: ''
                },
                breakpoints: {
                    1680: {
                        slidesPerView: 5,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    },
                    1366: {
                        slidesPerView: 5,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    },
                    1024: {
                        slidesPerView: 4
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    },
                    480: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                        pagination: {
                            el: '.swiper-pagination',
                            dynamicBullets: true
                        }
                    }
                }
            }
        };
    }
};
</script>

<style lang="scss" scoped>
.swiper-wrapper{
    margin-left: 50px;
    margin-right: 50px;
}
@media only screen and (max-width: 767px) {
    .mob-hide {
        display:none;
    }
}
@media only screen and (min-width: 768px) {
    .desktop-hide {
        display:none;
    }
}
</style>
